import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const noShowAppointmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNoShowAppointments: builder.query({
      query: ({ patientProfileId, patientCaseId, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Appointment/${patientProfileId}/${patientCaseId}/noshow-appointments`,
          method: "GET",
          headers,
        };
      },
      providesTags: [{ type: "NoShowAppointment" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetNoShowAppointmentsQuery } = noShowAppointmentsApi;
export default noShowAppointmentsApi;
